import SafeArea from "@/components/safe-area";
import Skeleton from "@/components/skeleton/Skeleton";
import StatusBarHeight from "@/components/status-bar-height";

export default function NavigationBarSkeleton() {
	return (
		<div className="flex-shrink-0">
			<StatusBarHeight />
			<SafeArea position="top" />
			<div className="flex h-12 items-center">
				<Skeleton className="w-5 h-5 rounded" />
				<Skeleton className="flex-1 mx-8 h-5" />
				<Skeleton className="w-5 h-5 rounded" />
			</div>
		</div>
	);
}
